import { StateTagType } from '@shared/ui-components/state-tag/models/tag.model';
import { InstallationStatusCode } from '@core/domain/model/services/individual-installation.model';

export enum TagElement {
  INVOICE = 'INVOICE',
  INSTALLATION = 'INSTALLATION',
  PROCEDURE = 'PROCEDURE',
  USER_ROLE = 'USER_ROLE',
  USER_STATE = 'USER_STATE',
}

export const TagsDirectory: TagsDirectoryTypes = {
  [TagElement.INVOICE]: {
    '1': 'alert',
    '300000000': 'alert',
    '300000001': 'alert',
    '300000004': 'completed',
    '300000005': 'alert',
    '300000006': 'completed',
    '300000009': 'low',
    '300000010': 'pending',
    '300000011': 'pending',
    default: 'pending',
  },
  [TagElement.INSTALLATION]: {
    [InstallationStatusCode.PENDING_SWITCH]: 'pending',
    [InstallationStatusCode.REQUESTED]: 'pending',
    [InstallationStatusCode.FORMALIZED]: 'completed',
    [InstallationStatusCode.FORMALIZED_ACCEPTED]: 'pending',
    [InstallationStatusCode.FORMALIZED_REJECTED]: 'alert',
    [InstallationStatusCode.FINALIZED]: 'low',
    default: 'pending',
  },
  [TagElement.PROCEDURE]: {
    '5': 'completed',
    '6': 'completed',
    '2000': 'pending',
    '300000000': 'pending',
    '300000002': 'completed',
    '300000004': 'completed',
    '300000005': 'completed',
    '300000006': 'alert',
    '300000007': 'pending',
    '300000008': 'pending',
    '300000009': 'pending',
    '300000010': 'completed',
    '300000011': 'pending',
    '300000012': 'pending',
    '300000013': 'pending',
    '300000014': 'pending',
    '300000015': 'pending',
    '300000016': 'pending',
    '300000017': 'pending',
    '300000018': 'pending',
    '300000019': 'pending',
    '300000020': 'completed',
    default: 'pending',
  },
  [TagElement.USER_ROLE]: {
    ADMIN: 'admin',
    USER: 'user',
    default: 'alert',
  },
  [TagElement.USER_STATE]: {
    REGISTERED: 'completed',
    CANCELLED: 'low',
    PENDING: 'pending',
    default: 'completed',
  },
};

export type TagsDirectoryTypes = {
  [prop in TagElement]: { [key: string]: StateTagType };
};
